export default __webpack_public_path__ + "static/media/pistol-torch-flat.3d5d116d.svg";